import { AuthProvider, LocalStorageKey } from '@ankr.com/auth';

export const getAuthProvider = () => {
  const authProvider =
    localStorage.getItem(LocalStorageKey.AuthProvider) ?? undefined;

  return authProvider as AuthProvider | undefined;
};
